import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { useDensityClass } from '@/design/density';
import { cx } from './cx';
import { useFieldControl } from './Field';
import { CONTROL_CLASS } from './Input';

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function Textarea({ className, rows = 4, ...rest }, ref) {
    const field = useFieldControl();
    const size = useDensityClass({ public: 'px-3 py-2.5 text-sm', app: 'px-2.5 py-1.5 text-xs' });
    return (
      <textarea
        ref={ref}
        rows={rows}
        {...field}
        {...rest}
        className={cx(CONTROL_CLASS, size, className)}
      />
    );
  },
);
